import { message, Steps } from "antd";
import { useState } from "react";
import { useNavigate } from 'react-router-dom';

// project modules
import AccountForm from "../../components/new-subscription-steps/AccountForm";
import { apiCall } from "../../helpers/apiHelper";
import { trimStringProps } from "../../helpers/objectHelper";

// apis
import * as AuthApi from '../../apis/authApi';

// models
import { ApiResponse } from "../../models/response";
import { accountRegisterViewModel } from "../../models/types/auth";

export default function SignupPage() {
  const [loading, setLoading] = useState(false);
  const abortController = new AbortController();
  const navigate = useNavigate();

  const steps: any[] = [
    {
      id: 0,
      title: "Sign Up"
    },
    {
      id: 1,
      title: "Kibosh Device",
    },
    {
      id: 2,
      title: "Billing Address",
    },
    {
      id: 3,
      title: "Kibosh Subscription",
    },
    {
      id: 4,
      title: "Payment",
    }
  ];

  const onCancel = () => {
    navigate({
      pathname: "/auth/login",
    });
  };

  const onSave = async (formData: accountRegisterViewModel) => {
    setLoading(true);

    formData.userName = formData.email;

    const response: ApiResponse = await apiCall(AuthApi.register(trimStringProps(formData), abortController.signal));

    if (response.success) {
      message.success("Your account created successfully");
      message.success("Please check your email to confirm.")

      navigate(`/not-confirmed-email?email=${formData.userName}`);
    } else
      message.error(response.error?.value);

    setLoading(false);
  };

  return (
    <>
    <view data-border="none">
      <section>
        <wrapper>
          <group data-space-horizontal="10" data-gap="10">
            <group>
              <space data-height="40"></space>
              <Steps
                current={0}
                items={steps}
              />
            </group>

          <group data-gap="10" data-direction="column">
            {/* <text data-weight="700" data-wrap="wrap">Kibosh Devices</text> */}
            <text data-wrap="wrap" data-length="700" data-weight="700" data-line="1.5" data-color="main-dark" data-font-style="italic" data-margin-vertical="10">
              * Please complete the signup process, verify your email, and follow the steps to activate your subscription
            </text>
          </group>
            <AccountForm
              cancelText="Cancel"
              okText="Sign up"
              parentLoading={loading}
              onCancel={onCancel}
              onSave={(formData) => onSave(formData!)} />
          </group>
        </wrapper>
      </section>
    </view>
    </>
  );
}
